import projectFetchers from '@/api/fetchers/content-studio/project';
import useReactQuery from '@/hooks/use-react-query';
import {CONTENT_LAB, DUBBING_LANGUAGES} from '../consts';

function useDubbingLanguagesQuery() {
  return useReactQuery<string[]>({
    queryKey: [CONTENT_LAB, DUBBING_LANGUAGES],
    queryFn: async () => {
      const response = await projectFetchers.getLanguages();
      return response || [];
    },
  });
}

export default useDubbingLanguagesQuery;
